import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './carousel-pagination-navigation.scss.js';

class CarouselPaginationNavigation extends s {
    constructor() {
        super(...arguments);
        this.nextText = '';
        this.previousText = '';
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return $ `<div class="swiper-nav ${this.rtl || isRTL() ? 'rtl' : ''}"><button class="swiper-button-prev pagination-arrow" aria-label="${this.previousText}"><span class="material-symbols-outlined" aria-hidden="true">chevron_left </span><span class="sr-only">${this.previousText}</span></button><div class="swiper-pagination-bullets" role="group" aria-label="Pagination"></div><button class="swiper-button-next pagination-arrow" aria-label="${this.nextText}"><span class="material-symbols-outlined" aria-hidden="true">chevron_right </span><span class="sr-only">${this.nextText}</span></button></div>`;
    }
}
CarouselPaginationNavigation.styles = css_248z;
__decorate([
    e({ type: Boolean })
], CarouselPaginationNavigation.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], CarouselPaginationNavigation.prototype, "nextText", void 0);
__decorate([
    e({ type: String })
], CarouselPaginationNavigation.prototype, "previousText", void 0);
customElements.define('carousel-pagination-navigation', CarouselPaginationNavigation);

export { CarouselPaginationNavigation };
